import {Router} from '@angular/router';
import {inject} from '@angular/core';
import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-real-time-aside',
	templateUrl:'./RealTimeAsidePage.html',
	styles: [],
	styleUrls:['./RealTimeAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
],
	standalone:true
})
export class RealTimeAsidePage
{
	private router: Router = inject(Router);
	navigateTo(route: string) {
	    this.router.navigate(['/' + route]);
	}

}
